import { TokenResponse, useGoogleLogin } from '@react-oauth/google';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGoogleToken } from '../../Slice/AllParameter';
import { AppDispatch, RootState } from '../../Store';
import AuftragTerminierenComponent from '../../component/AuftragTerminierenComponent/AuftragTerminierenComponent';
import MapShowLocationsComponent, { IMapShowLocationsComponent } from '../../component/MapShowLocations/MapShowLocationsComponent';
import ScrollToTopBadge from '../../component/ScrollToTop';
import { IAuftrag } from '../../types/Types';
import Styles from './auftragterminieren.module.scss';

export type IAuftragsdaten = {
  stunde: string,
  minute: string,
  wiedervorlagetage: string,
  terminierungFertig: boolean,
  termindatum: string,
}

const emptyAuftragsdaten: IAuftragsdaten = {
  stunde: "01",
  minute: "00",
  wiedervorlagetage: "1",
  terminierungFertig: false,
  termindatum: "",
}

/**
 * @author noone
 */
export type IAuftragTerminierenProps = {
  liste: IAuftrag[];
  statusChanged: () => void;
}
export default function AuftragTerminieren(props: IAuftragTerminierenProps) {

  //const navigate = useNavigate();
  //const { t } = useTranslation();
  //const [getUserProfiles] = useGetUserProfilesMutation();

  const googleToken = useSelector((state: RootState) => state.allParameter.googleToken);

  const dispatch = useDispatch<AppDispatch>();
  //const [termindatum, setTermindatum] = useState<string>();
  //const [ausfuehrender, setAusfuehrender] = useState<string>();
  //const [userProfiles, setUserProfiles] = useState<IOnlyUserProfile[]>([]);
  //const [calendarId, setCalendarId] = useState<string>("primary");

  const [auftragLocations, setAuftragLocations] = useState<IMapShowLocationsComponent[]>([]);
  const [map1, setMap1] = useState<Map<IAuftrag, number>>(new Map());
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse: TokenResponse) => {
      const accessToken = tokenResponse.access_token;
      dispatch(setGoogleToken(accessToken!));
      console.log("Access Token:", accessToken);
    },
    onError: (err) => console.error('Login fehlgeschlagen', err),
    scope: 'https://www.googleapis.com/auth/calendar',
    flow: 'implicit', // oder 'auth-code' je nach Setup
  });

  const changeColor = (auftraguid: string, color: string) => {
    setAuftragLocations((prevLocations) =>
      prevLocations.map((auftrag) =>
        auftrag.uid === auftraguid ? { ...auftrag, color } : auftrag
      )
    );
  }

  const statusChanged = () => {
    props.statusChanged();
  }

  useEffect(() => {
    // 
    const mapTmp = new Map();
    props.liste.map((auftrag, index) => {
      mapTmp.set(auftrag, (index + 1));
    });
    setMap1(mapTmp);

    let listeTmp: IMapShowLocationsComponent[] = [];
    props.liste.forEach(it => listeTmp.push({ uid: it.uid, numberOnMap: mapTmp.get(it), lat: it.lat, lng: it.lng, color: "#4285F4" }));
    setAuftragLocations(listeTmp);

    setIsLoaded(true);
  }, [props]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (

    <div className={Styles.grid1} >

      <div style={{ overflowY: 'auto', height: '100%' }}>

        {(googleToken === null || googleToken === undefined) &&
          <button className="btn btn-warning" onClick={() => login()}>
            <i className='bi bi-exclamation-diamond-fill'></i> Calendar aktivieren <i className='bi bi-exclamation-diamond-fill'></i>
          </button>
        }


        {props.liste.map((auftrag, index) =>
          <AuftragTerminierenComponent key={index} changeColor={changeColor} statusChanged={statusChanged} numberOnMap={map1.get(auftrag)!!} auftrag={auftrag} googleToken={googleToken} />
        )}

        <ScrollToTopBadge />

      </div>

      <div style={{
        position: 'sticky',
        top: 0,
        height: '100vh',
      }}>
        {isLoaded &&
          <>
            <MapShowLocationsComponent locations={auftragLocations} />
          </>}
      </div>
    </div >
  );

}
